import { render, staticRenderFns } from "./Meal_plan_internal.vue?vue&type=template&id=9a860656&scoped=true&"
import script from "./Meal_plan_internal.vue?vue&type=script&lang=js&"
export * from "./Meal_plan_internal.vue?vue&type=script&lang=js&"
import style0 from "./Meal_plan_internal.vue?vue&type=style&index=0&id=9a860656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a860656",
  null
  
)

export default component.exports